/**
 * json和string数据互转
 * params.parse
 *		@param {string} str 要解析为json的string,
 * params.stringify
 * 		@param {object} json 要字符化的json “&、=”链接，decodeURIComponent处理
 */

var json2param = (function ($) {
  function parse(str) {
    var params = {},
      pieces = str.split("&"),
      pair,
      i,
      l

    for (i = 0, l = pieces.length; i < l; i++) {
      pair = pieces[i].split("=")
      if (!!$.trim(pair[0])) {
        // 没有值得string参数，转换后给默认值true(boolean)
        params[decodeURIComponent(pair[0])] = pair.length == 2 ? decodeURIComponent(pair[1]) : true
      }
    }
    return params
  }

  function stringify(json) {
    var re = []

    $.each(json, function (k, v) {
      re.push(k + "=" + encodeURIComponent(v))
    })

    return re.join("&")
  }

  return {
    parse: parse,
    stringify: stringify,
  }
})(jQuery)

export default json2param
